const SpecialReasonForTrip = Object.freeze({
  HONEYMOON: 'honeymoon',
  ANNIVERSARY: 'anniversary',
  BIRTHDAY: 'birthday',
  ROMANTIC: 'romantic',
  FAMILY_TRIP: 'family_trip',
  FRIENDS_TRIP: 'friends_trip',
  SOLO_ESCAPE: 'solo_escape',
  BUCKET_LIST: 'bucket_list',
  JUST_BECAUSE: 'just_because',
} as const);

export type SpecialReasonForTrip = (typeof SpecialReasonForTrip)[keyof typeof SpecialReasonForTrip];
export const allSpecialReasonForTrip: [SpecialReasonForTrip, ...SpecialReasonForTrip[]] = Object.values(
  SpecialReasonForTrip
) as [SpecialReasonForTrip, ...SpecialReasonForTrip[]];

export default SpecialReasonForTrip;
